import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/Loader';

function LoginCallback() {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    instance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          navigate('/');
        }
      })
      .catch((error) => {
        console.error('Login error:', error);
      });
  }, [instance, navigate]);

  return (
    <div className="row" data-testid="auth-loader">
      <div className="col-12 d-flex flex-column p-5 m-5">
        <Loader loadingMessage="Loading" />
      </div>
    </div>
  );
}

export default LoginCallback;
